import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Phone.svg",
  "use": "Phone.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Phone.svg\"><path d=\"M41.01,56.0208h-18a5,5,0,0,1-5-5v-38a5,5,0,0,1,5-5h18a5,5,0,0,1,5,5v38A5,5,0,0,1,41.01,56.0208Zm1-40a1,1,0,0,0-1-1h-18a1,1,0,0,0-1,1v32a1,1,0,0,0,1,1h18a1,1,0,0,0,1-1Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol